// petaNamaCustomer — { id: nama } untuk customer yang BENAR-BENAR tampil di layar.
//
// ⛔ KELAS H (23 September 2026). Tiga layar (Dashboard, Permintaan Desain, Pembayaran
//    Menunggu) dulu memetakan nama lewat `GET /customers?limit=200` — 200 customer PERTAMA.
//    Volume setahun ±3.000 FA berarti ribuan customer: customer ke-201 dst. tampil sebagai
//    id mentah, dan tidak ada yang berkata "terpotong".
//
//    Yang dibutuhkan layar hanya nama baris yang sedang tampil, jadi dibaca per POTONGAN id
//    (`GET /customers?ids=…` — pagar peran & cakupan sama dengan daftarnya). Id di luar
//    cakupan tidak kembali: layar jatuh ke id, persis perilaku lama untuk yang tidak terbaca.
import { api } from "./api";

const POTONG = 100;

export async function petaNamaCustomer(ids) {
  const unik = [...new Set((ids || []).filter(Boolean))];
  const peta = {};
  for (let i = 0; i < unik.length; i += POTONG) {
    const potong = unik.slice(i, i + POTONG);
    const r = await api.get("/customers", { params: { ids: potong.join(","), limit: 200 } });
    (r.data?.items || []).forEach((c) => { peta[c.id] = c.name; });
  }
  return peta;
}

export default petaNamaCustomer;
